import { Component, OnInit, ViewContainerRef } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';
import { DigitalFormDataVM, DigitalFormQuestionsVM, DigitalFormQuestionsCategoriesVM, DigitalFormVM, DigitalFormQuestionTypesVM, ModelAnswerList, UpdateQuestion, FormStatusTypesVM } from '../../../favourite-dialog/favourite-dialog-modal';
import { ActivatedRoute, Router } from '@angular/router';
import { DigitalFormService } from '../../digital-form.service';
import { AppService } from '../../../../../app.service';
import { DomSanitizer } from '@angular/platform-browser';
import { MatDialog } from '@angular/material/dialog';import { FileReaderEvent } from '../../../setup-implement/setup-implement.component';
import { EditPhotoDigitalComponent } from '../edit-photo-digital/edit-photo-digital.component';
import { NotificationsService } from 'angular2-notifications';
import { PreferencesService } from '../../../../../modules/preferences/preferences.service';

@Component({
  selector: 'app-digital-form-categorylist',
  templateUrl: './digital-form-categorylist.component.html',
  styleUrls: ['./digital-form-categorylist.component.scss'],
  animations: [
    trigger(
        'enterAnimation', [
            transition(':enter', [
                style({ transform: 'translateY(25%)', opacity: 0 }),
                animate('500ms', style({ transform: 'translateY(0)', opacity: 1 }))
            ]),
            transition(':leave', [
                style({ transform: 'translateY(0)', opacity: 1 }),
                animate('500ms', style({ transform: 'translateY(100%)', opacity: 0 }))
            ])
        ]
    )]
})
export class DigitalFormCategorylistComponent implements OnInit {
  formId:number;
  uploadId:number;
  parentCatId:number;
  DigtalFormOverview:DigitalFormDataVM;

  defaultsectionQuestion : DigitalFormQuestionsVM[]=[];
  formQSections : DigitalFormQuestionsCategoriesVM[]=[];
  formQCategories : DigitalFormQuestionsCategoriesVM[]=[];
  formQuestions : DigitalFormQuestionsVM[]=[];
  form :DigitalFormVM;
  questionTypes:DigitalFormQuestionTypesVM[]=[];
  panelOpenState = false;
  xpandStatus=true;
  update:boolean=false;
  selectedformQuestions : DigitalFormQuestionsVM[]=[];
  statusTypes:FormStatusTypesVM[]=[];
  constructor( private _route: ActivatedRoute, private _router: Router,
    public toastr: NotificationsService, vcr: ViewContainerRef,
    public _formService: DigitalFormService,private _editPhotoDialog: MatDialog,
    private _appService: AppService,private _sanitizer: DomSanitizer,
    private readonly _pref: PreferencesService,) { 

    }


  ngOnInit() {
    
  this._appService.setPageTitle('Update - Digital Inspection');
  //this._appService.setPageSubTitle('');
  this.formId = +this._route.snapshot.paramMap.get('formId');

  this.uploadId = +this._route.snapshot.paramMap.get('uploadId');
  this.parentCatId = +this._route.snapshot.paramMap.get('catId');

  console.log("parentid", this.parentCatId)
  if(this.formId>0 && this.uploadId>0 && this.parentCatId>0){
    this.LoadFormUploadDetails();
  }


}

LoadFormUploadDetails(){
  this._formService.GetDigitalFormUploadDetails(this.formId, this.uploadId).subscribe(res=>{
    console.log("result___", res)
    this.DigtalFormOverview=res;

    this.form =this.DigtalFormOverview.DigitalForms;
    this.formQCategories=this.DigtalFormOverview.ParentCategories.filter(x=>x.QuestionCatId==this.parentCatId);;

    this.formQSections=this.DigtalFormOverview.CategorySections.filter(x=>x.ParentCatId==this.parentCatId);;

    this.formQuestions=this.DigtalFormOverview.Questions;
    this.questionTypes=this.DigtalFormOverview.QuestionTypes;
    this.statusTypes=this.DigtalFormOverview.FormStatusList;
    //this.formQCategories = this.formQCategories.filter(x=>x.QuestionCatId==this.parentCatId);
    //this.formQSections = this.formQSections.filter(x=>x.ParentCatId==this.parentCatId);

   
    this.formQSections.map(s=>{
      this.formQuestions.map(q=>{
        if(s.QuestionCatId == q.QuestionCatId){
          
          this.selectedformQuestions.push(q);
        }else{

        }
      })
    })

  })
}

getImage(image: string) {
  return this._sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + image);
}

EditImage(qId:number,photo:string, Question:DigitalFormQuestionsVM) {
  const editPhotoModalRef = this._editPhotoDialog.open(EditPhotoDigitalComponent, {
    data: { photoWithExt: 'data:image/png;base64,' + photo }
  });
  editPhotoModalRef.afterClosed().subscribe(res => {
    if (res != null) {
      console.log("updated_photo", res.photo)
     // this.LoadFormUploadDetails();
      Question.EditedQuestionImage = res.photo;
    }
  });
}
SelectedQuestion:DigitalFormQuestionsVM;
ModelAnswers:ModelAnswerList[]=[];
selectedId:number=0;
UpdateFreetextOrNumber(event:any, Question:DigitalFormQuestionsVM){
  console.log(event.target.value, Question)
 this.SelectedQuestion =Question;


 Question.ModelAnswers.map(x=>{
   x.Answer = event.target.value;
   x.QuestionName = Question.QTitle;
   x.select=true;
 })
  
}
//update question

UpdateAllQuestions(){
  //update FormUpload data
console.log("selectedId", this.selectedId)
console.log("selected Question update", this.SelectedQuestion)
  
console.log("questuon", this.formQuestions )
console.log("selectedlist", this.selectedformQuestions)
let UpdateQuestions =  new UpdateQuestion();
UpdateQuestions.FormId=this.formId;
UpdateQuestions.UploadId=this.uploadId;
UpdateQuestions.ParentCatId=this.parentCatId;
UpdateQuestions.Questions=this.selectedformQuestions;
this.update=true;
this._formService.UpdateQuestionsForSpecifcCategory(UpdateQuestions).subscribe(res=>{
  console.log("res", res)
  if(res==true){
    this.toastr.success("Sucessfully Updated Question")
     this.LoadFormUploadDetails();
     this.update=false;
  }else{
    this.toastr.error("Unable to Update the Question")

  }
})


}

GetSelectedQuestion(QId:number){
  this.panelOpenState=true;

  if(this.SelectedQuestion!=null && this.SelectedQuestion!=undefined)
  if(QId!=this.SelectedQuestion.QuestionId){
    this.SelectedQuestion=null;
  }
}

SelectAnswer(value:number,AnswerId:number,Question:DigitalFormQuestionsVM){
  console.log("valuee", value)
  Question.ModelAnswers.map(x=>{
    if(x.AnswerId ==AnswerId){
      x.select=true;
    }else{
      x.select=false;
    }
  })
}

Imagelist:string[]=[];
image:string;
ViewAll(){
  //this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
  this._pref.GetReplaceExistingTabStatus().subscribe(res=>{
    if(res=="True"){
      this._router.navigate(['/digitalform/fill', this.formId, this.uploadId]);
    }else{             
      window.open('digitalform/fill/'+ this.formId+ '/'+ this.uploadId,'_blank'); 
    }
});
}

//  photo upload
onSelectPhoto(event,Question:DigitalFormQuestionsVM) {
  if (event.target.files && event.target.files[0]) {
    this.Imagelist = [];
      var reader = new FileReader();

      reader.readAsDataURL(event.target.files[0]); // read file as data url
      reader.onload = (event: any) => { // called once readAsDataURL is completed
          var imageUrl = (event.target["result"]).split(',');
          //this.saveSchematicImage(imageUrl, this.selectedSechamnticImage);
         // console.log("selectedImage", imageUrl[1])
         // console.log("imageUrl", imageUrl)
          this.Imagelist.push(imageUrl[1]);
          this.image =imageUrl[1];

        if(Question.UploadImages==null){
          Question.UploadImages = this.Imagelist;
        }else{
          Question.UploadImages.push(this.image)
        }
    
      }
  }
}

deleteimage(image:string,Question:DigitalFormQuestionsVM){
    Question.UploadImages = Question.UploadImages.filter(x=>x!=image);
    
}


UpdateStatus(){
  this._formService.UpdateUploadFormStatus(this.uploadId, this.form.FormStatusID, -1).subscribe(res=>{
    if(res){
      this.toastr.success("Sucessfully update the status")
    }else{
      this.toastr.error("Unable to update the status")
    }
  })
}


}
